// const operations = [
//   {
//     id: "70000056",
//     name: "Islamic Development Bank / Leasing",
//     legacyReference: "2EGT0094",
//     state: "On Disbursement",
//     suspensionState: "NotOnHold",
//     approvedCurrency: {
//       code: "USD",
//       name: "United States Dollar",
//       decimals: 2,
//     },
//     revisedApprovedAmount: 200000000.0,
//     financialStatus: "In Gestation (Active)",
//     financialStatusCode: "60",
//     disbursementStatus: "Partially Disbursed",
//     disbursementStatusCode: "02",
//     projectId: "2333",
//     modeOfFinanceFund: {
//       id: "EGY0094.000008",
//       modeOfFinanceFund: {
//         modeOfFinance: {
//           id: "7",
//           name: "Leasing",
//         },
//         fund: {
//           id: "1",
//           name: "Islamic Development Bank",
//         },
//       },
//     },
//   },
//   {
//     id: "70000057",
//     name: "Islamic Development Bank / Leasing",
//     legacyReference: "2EGT0100",
//     state: "On Disbursement",
//     suspensionState: "NotOnHold",
//     approvedCurrency: {
//       code: "USD",
//       name: "United States Dollar",
//       decimals: 2,
//     },
//     revisedApprovedAmount: 250000000.0,
//     financialStatus: "In Gestation (Active)",
//     financialStatusCode: "60",
//     disbursementStatus: "Partially Disbursed",
//     disbursementStatusCode: "02",
//     projectId: "2333",
//     modeOfFinanceFund: {
//       id: "EGY0094.000028",
//       modeOfFinanceFund: {
//         modeOfFinance: {
//           id: "7",
//           name: "Leasing",
//         },
//         fund: {
//           id: "1",
//           name: "Islamic Development Bank",
//         },
//       },
//     },
//   },
// ];

/* Current State*/
const operations = [
  {
    id: "70000056",
    name: "Leasing / Islamic Development Bank",
    project: {
      id: 2333,
    },
  },
  {
    id: "70000057",
    name: "Leasing / Islamic Development Bank",
    project: {
      id: 2333,
    },
  },
  {
    id: "70000056",
    name: "Leasing / Islamic Development Bank",
    project: {
      id: 2420,
    },
  },
  {
    id: "70000057",
    name: "Leasing / Islamic Development Bank",
    project: {
      id: 2420,
    },
  },
];

export default operations;
